import { getDecimals } from "helpers/getNumberFormats";

const DECIMAL_PLACES = 2;

const EGRESOS_KEYS = [
  "imss", "selfConsumption", "perceptions", "cylinderRepair",
  "portableEquipmentMaintenance", "tankAcquisition", "tankAccessories",
  "insuranceFinanceFees", "commissions", "specialPricePromotion",
  "christmasBonus", "taxes", "claimsTheft", "platformVoucher",
  "foodVouchersAdvertising", "floorRights",
];

export const ALL_NUMERIC_KEYS = [
  "price", "sale", "costSale",
  ...EGRESOS_KEYS, "efParticipation",
  "profit", "adminExpenses", "profitSharing1", "profitSharing2",
];

/**
 * Calcula los campos derivados de una unidad especial.
 * @param {Object} body - Objeto con los campos numéricos del formulario
 * @returns {Object} Campos calculados: grossSale, netSale, profit, distributionExpenses, adminExpenses, profitSharing1, profitSharing2
 */
export const calculateSpecialUnitFields = (body) => {
  const sale = body.sale || 0;
  const price = body.price || 0;
  const costSale = body.costSale || 0;
  const efParticipation = body.efParticipation || 0;

  const grossSale = parseFloat(getDecimals(sale * price, DECIMAL_PLACES)) || 0;
  const netSale = grossSale;
  const costOnSalePercentage = sale * costSale;
  const profit = parseFloat(getDecimals(netSale - costOnSalePercentage, DECIMAL_PLACES)) || 0;

  const distributionExpenses = EGRESOS_KEYS
    .reduce((sum, key) => parseFloat(getDecimals(sum + (body[key] || 0), DECIMAL_PLACES)) || 0, 0);

  const adminExpenses = 0;
  const profitSharing1 = parseFloat(getDecimals(profit - distributionExpenses - adminExpenses, DECIMAL_PLACES)) || 0;
  const profitSharing2 = parseFloat(getDecimals(profitSharing1 + efParticipation, DECIMAL_PLACES)) || 0;

  return {
    grossSale,
    netSale,
    profit,
    distributionExpenses,
    adminExpenses,
    profitSharing1,
    profitSharing2,
  };
};
